import { render, staticRenderFns } from "./Warehouse_close.vue?vue&type=template&id=caa06438&scoped=true&"
import script from "./Warehouse_close.vue?vue&type=script&lang=js&"
export * from "./Warehouse_close.vue?vue&type=script&lang=js&"
import style0 from "./Warehouse_close.vue?vue&type=style&index=0&id=caa06438&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa06438",
  null
  
)

export default component.exports